import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import { Input, InputNumber } from 'antd'
import StyledLoader from 'components/Elements/StyledLoader'
import SectionTitle from 'components/SectionTitle'
import { DataContext } from 'contexts/DataContextContainer'
import { mySQLDate } from 'lib/date'
import { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useBookMutation, useBookQuery } from 'store/queries'
import { BookSettingsContainer } from './style'

function BookSettings() {
  const { bookId } = useParams()
  const { t } = useTranslation()
  const { lang } = useContext(DataContext)

  const [title, setTitle] = useState('')
  const [promptFreq, setPromptFreq] = useState(1)
  const [startDate, setStartDate] = useState(new Date())

  const startDatePicker = useRef(null)

  const { data: book } = useBookQuery(bookId)
  const bookMutation = useBookMutation(bookId)

  useEffect(() => {
    if (book?.id) {
      setTitle(book.title)
      setPromptFreq(book.prompt_frequency)
      setStartDate(new Date(book.start_datetime))
    }
  }, [book.id, book.title, book.prompt_frequency, book.start_datetime])

  const updateBookSettings = () => {
    const payload = {
      title,
      prompt_frequency: promptFreq,
    }

    if (!book.welcome_sent) {
      payload.start_datetime = mySQLDate(startDate)
    }

    bookMutation.mutate(payload)
  }

  if (!book?.id) {
    return <StyledLoader />
  }

  return (
    <BookSettingsContainer className="section-container">
      <div className="edit-container modal-custom-body p20">
        <SectionTitle>{t('edit_book_info')}</SectionTitle>
        <div className="info-row">
          <div className="info-item">
            <div className={`info-label`}>{t('title')}:</div>
            <Input
              size="large"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        </div>
        <div className="info-row">
          <div className="frequency">
            <div className={`info-label`}>
              {t('send_new_story_prompt_every')}
            </div>
            <InputNumber
              size="large"
              min={1}
              value={promptFreq}
              onChange={(value) => setPromptFreq(value)}
              style={{ width: 60, marginLeft: 8, marginRight: 8 }}
              data-testid="prompt-freq-input"
            />
            <div className={`info-label`}>{t('days_update')}</div>
          </div>
        </div>
        {!book.welcome_sent && (
          <div className="info-row">
            <div className="start-date">
              <div className={`info-label`}>{t('start_date')}</div>
              <DatePickerComponent
                placeholder="Choose a date"
                ref={startDatePicker}
                value={startDate}
                firstDayOfWeek={1}
                format="dd/MM/yyyy"
                allowEdit={false}
                showClearButton={false}
                showTodayButton={false}
                change={(evt) => setStartDate(evt.value)}
                close={() => {
                  if (startDatePicker) startDatePicker.current.focusOut()
                }}
                focus={() => {
                  if (startDatePicker) startDatePicker.current.show()
                }}
                locale={lang}
              />
            </div>
          </div>
        )}
      </div>

      <div className="edit-container modal-custom-footer">
        <div className="save-section actions">
          <Button
            className="btn-blue btn-dash"
            onClick={updateBookSettings}
            disabled={!title}
          >
            {t('save')}
          </Button>
        </div>
      </div>
    </BookSettingsContainer>
  )
}

export default BookSettings
